import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import { toSign } from '@/utils/HmacSHA';

export interface collectData {
  i: string; // 事件id
  d: any; // 收集数据 json 包含uid
  t: string; // 时间戳【13位，毫秒】
}
export interface collectHeader {
  deviceOs: string;
  deviceId: string;
  deviceModel: string;
  deviceBrand: string;
  netType: string;
  data: collectData;
}

function getMacPromise(): any {
  return new Promise((resolve, reject) => {
    if ((window as any).raw) {
      (window as any).raw.getmac({}, (res: any) => {
        resolve(res);
      });
    }
  });
}

// 埋点反馈
export async function boxCollect(ch: string, key?: any) {
  const res = await getMacPromise();
  let sign = toSign(ch, key);
  if ((window as any).raw) {
    (window as any).raw.catchJsError({
      errorInfo: JSON.stringify({
        name: 'hook',
        ch,
        key
      })
    });
  }
  return request<any>({
    method: 'POST',
    headers: {
      device: 'pc',
      appv: localStorage.getItem('appv')?.replace(/&.+/, ''),
      channel: localStorage.getItem('channel'),
      deviceOs: res.data.os,
      deviceId: res.data.mac,
      deviceModel: '',
      deviceBrand: '',
      netType: ''
    },
    url: httpApi.collection.boxCollect,
    data: {
      ...sign
    }
  });
}
